import { render, staticRenderFns } from "./event-deatil-action.vue?vue&type=template&id=3a41b13c&"
import script from "./event-deatil-action.vue?vue&type=script&lang=js&"
export * from "./event-deatil-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a41b13c')) {
      api.createRecord('3a41b13c', component.options)
    } else {
      api.reload('3a41b13c', component.options)
    }
    module.hot.accept("./event-deatil-action.vue?vue&type=template&id=3a41b13c&", function () {
      api.rerender('3a41b13c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/events/event-detail-action/event-deatil-action.vue"
export default component.exports